import React, { Suspense, useCallback, useState } from 'react';
import { PermissionProtected } from '@stigg-components';
import { EnvironmentPermissionActions } from '@stigg-permissions';

const ProvisionSubscriptionAIDialog = React.lazy(() =>
  import('./ProvisionSubscriptionAIDialog').then((module) => ({ default: module.ProvisionSubscriptionAIDialog })),
);

export const useProvisionSubscriptionWithAIDialog = () => {
  const [isProvisionSubscriptionWithAIDialogOpen, setIsProvisionSubscriptionWithAIDialogOpen] = useState(false);

  const openProvisionSubscriptionWithAIDialog = useCallback(() => setIsProvisionSubscriptionWithAIDialogOpen(true), []);
  const closeProvisionSubscriptionWithAIDialog = useCallback(
    () => setIsProvisionSubscriptionWithAIDialogOpen(false),
    [],
  );

  const provisionSubscriptionWithAIDialog = (
    <Suspense fallback={null}>
      <PermissionProtected permission={EnvironmentPermissionActions.SubscriptionWrite}>
        <ProvisionSubscriptionAIDialog
          isOpen={isProvisionSubscriptionWithAIDialogOpen}
          onClose={closeProvisionSubscriptionWithAIDialog}
        />
      </PermissionProtected>
    </Suspense>
  );

  return {
    provisionSubscriptionWithAIDialog,
    openProvisionSubscriptionWithAIDialog,
    closeProvisionSubscriptionWithAIDialog,
  };
};
